import React from "react";
import { useMatch } from "@tanstack/react-router";
interface AuthenticatedOnlyProps {
    children: React.ReactNode;
}
const AuthenticatedOnly: React.FC<AuthenticatedOnlyProps> = ({ children }) => {
    const match = useMatch({ from: '/_authenticated', shouldThrow: false })
    return match ? <>{children}</> : undefined;
};
export default AuthenticatedOnly;